import React, { useState, useEffect, useMemo } from 'react'
import { withTranslation } from 'react-i18next'

import './Header.scss'

import { isHintShown, markHintIsShown } from '../../../../../utils/hintsManager'

const HINT_NAME = 'editor-modal-header-nav'

const Header = ({
    i18n,
    title,
    navItems = [],
    classes = [],
    activeNavItemId,
    onClose = () => {},
    onChangeNavItem = () => {},
    isCloseIcon = true,
}) => {
    const [showNavHint, setShowNavHint] = useState(false)

    useEffect(() => {
        if (navItems.length < 2) {
            return
        }
        const isShown = isHintShown(HINT_NAME)
        setShowNavHint(!isShown)
    }, [navItems])

    const onCloseHint = () => {
        markHintIsShown(HINT_NAME)
        setShowNavHint(false)
    }

    const renderNav = useMemo(() => {
        return (
            <ul className="modal-header__nav">
                {Object.values(navItems).map((item, i) => {
                    const isActive = activeNavItemId === item.id
                    return (
                        <li
                            className={`modal-header__nav-item${isActive ? ' modal-header__nav-item--is-active' : ''}`}
                            key={item.id}
                            onClick={() => onChangeNavItem(item.id)}
                        >
                            <p className={!isActive && showNavHint ? 'with-hint' : ''}>
                                <span>{item.label}</span>
                            </p>
                        </li>
                    )
                })}
            </ul>
        )
    }, [navItems, activeNavItemId, onChangeNavItem, showNavHint])

    const renderHint = useMemo(() => {
        return (
            <div className="modal-header__hint">
                <div className="modal-header__hint__info">
                    <div className="modal-header__hint__image"></div>
                    <div className="modal-header__hint__text">
                        {i18n.t('Navigate through tabs to customize your project')}
                    </div>
                </div>
                <button className="modal-header__hint__button" onClick={() => onCloseHint()}>
                    OK
                </button>
            </div>
        )
    }, [showNavHint])

    return (
        <div className={`modal-header ${classes.join(' ')}`}>
            {title && (
                <div className="modal-header__title" title={title}>
                    {title}
                </div>
            )}
            {navItems.length ? renderNav : null}
            {showNavHint ? renderHint : null}
            {isCloseIcon ? <div className="modal-header__close" onClick={() => onClose()}></div> : null}
        </div>
    )
}

export default withTranslation('translations')(Header)
